import React from 'react';
import { Alert, AlertTitle, Link, Typography } from '@mui/material';
import { INTEGRATION_SETTINGS_COPY as COPY } from '../utils/integrationSettingsCopy';

/**
 * Shown on the Shopify install / first-time credentials window so Jordan
 * sees what Motzu copies from the shop before they approve access.
 */
const ShopifyDataCollectionNotice: React.FC = () => (
  <Alert
    severity="info"
    icon={false}
    sx={{ alignItems: 'flex-start', '& .MuiAlert-message': { width: '100%' } }}
  >
    <AlertTitle sx={{ mb: 0.5 }}>{COPY.dataCollection.title}</AlertTitle>
    <Typography variant="body2" sx={{ mb: 1 }}>
      {COPY.dataCollection.intro}
    </Typography>
    <Typography variant="body2" sx={{ mb: 0.5 }}>
      <strong>{COPY.dataCollection.collectLabel}.</strong> {COPY.dataCollection.collect}
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
      <strong>{COPY.dataCollection.notCollectLabel}.</strong> {COPY.dataCollection.notCollect}
    </Typography>
    <Typography variant="body2">
      {COPY.dataCollection.retention}{' '}
      <Link href="/privacy" target="_blank" rel="noopener noreferrer">
        {COPY.dataCollection.privacyLink}
      </Link>
    </Typography>
  </Alert>
);

export default ShopifyDataCollectionNotice;
